import React, { useState } from "react";
import "../../pages/NavbarHeader/navbarheader.css";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import { motion } from "framer-motion";
import Header4 from "./Header4";
import { useTranslation } from "react-i18next";
import NavList from "../GenericComponents/NavList";
import { Props } from "./Header3.d";

const Header3: React.FC<Props> = ({setState}) => {
  const { t } = useTranslation();
  const menu = t("menu", { returnObjects: true });
  const data: any[] = Array.isArray(menu) ? menu : [];

  const [hoveredMenuId, setHoveredMenuId] = useState<string | null>(null);

  const handleMouseEnter = (id: string) => {
    setHoveredMenuId(id);
  };

  const handleMouseLeave = () => {
    setHoveredMenuId(null);
  };
    const subMenuAnimate = {
      enter: {
        opacity: 1,
        rotateX: 0,
        transition: {
          duration: 0.5
        },
        display: "block",
      },
      exit: {
        opacity: 0,
        rotateX: -15,
        transition: {
          duration: 0.5,
          delay: 0.3
        },
        transitionEnd: {
          display: "none"
        }
      }
    };
    return (
      <div className="header3">
      <nav className="navLinks">
        <ul className="navlinks_ul">
          {data?.map((navlink, i) => (
            (navlink.show && 
              <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              >
                <li
                  key={i}
                  className="navlink_li"
                  onMouseEnter={() => handleMouseEnter(navlink.id)}
                  onMouseLeave={handleMouseLeave}
                >
                  <Link to={navlink.navigateTo}>{navlink.label}</Link>

                  {/* Submenu */}
                  {hoveredMenuId === navlink.id && navlink.submenus && (
                  <motion.div
                    className="sub-menu"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}
                  >
                    {navlink.submenus.map((sub: any, j: number) => (
                      <NavList key={j} navigateTo={sub.navigateTo} label={sub.label} />
                    ))}
                  </motion.div>
                  )}
                </li>
              </motion.div>
            )
          ))}
        </ul>
      </nav>
    </div>
    );
  };
  export default Header3;